import React,{ Component } from "react";
import {Input,Menu,Modal,Image,Button} from 'antd'
import './index.less'
import {IsPC, IsPcChild} from "../../components/IsPc";
import Axios from '../../components/request/axios'
import GetUrlParam from '../../components/getUrlParam'
import WS from '../../components/websocket'
import moment from 'moment'
import img from "../index/image/banner.jpg";
import getIdFromUrl from "../../components/getIdFromUrl";
import baiduico from './image/baidu.png'
const {Search}=Input;
const { SubMenu } = Menu;
export default class Index extends Component{
    state = {
        current: 'index_#/',//默认选中首页
        system_settings:{},
        isModalOpen:false, ///推广弹框
        extension:{},
        isGrade_name:0,
        friend_link_num:1
        //keyPath:[]
    };
    //解决react报错：Can't perform a React state update on an unmounted component
    componentWillUnmount() {//参考链接 https://blog.csdn.net/u010565037/article/details/88716681
        this.setState = (state,callback)=>{
            return;
        };
    }
    componentDidMount() {
        let userInfo=window.localStorage.getItem('userInfo');
        //console.log(userInfo);
        if(userInfo){///用户已经登录过了
            WS();//连接websocket
            userInfo=JSON.parse(userInfo);
            //console.log(userInfo);
            this.setState({
                userName:userInfo.nickname?userInfo.nickname:userInfo.username,
                userInfo,
                nickname:userInfo.nickname,
                isGrade_name:userInfo.grade_name&&(getIdFromUrl(userInfo.grade_name)==='1'||getIdFromUrl(userInfo.grade_name)==='2')?1:0
            });
        }
        this.props.toSetMenus();
        let current=window.sessionStorage.getItem("current");//获取导航栏的选中状态
        console.log(current);
        if(!current){//没有存储过，说明关闭了窗口，将首页存储进去
            window.sessionStorage.setItem("current","index_#/");
        }else {//如果有值，重新将值设置一下
            this.setState({
                current:current,
            })
        }
        if(window.location.hash.match('newshow')&&!GetUrlParam('key')){///联系我们菜单
            this.setState({
                current:'about us'
            })
        }
        let _this=this;
        Axios.get('/api/v1/friend_link/').then((res)=>{///请求新闻中心的新闻
            if(res){
                let results = res.results;
                _this.setState({
                    friend_link:results,
                    friend_link_num:Math.ceil(results.length/4)
                })
            }
        });
        Axios.get('/api/v1/system_settings/').then((res)=>{///请求新闻中心的新闻
            if(res){
                let results = res.results;
                if(results.length>0){
                    _this.setState({
                        system_settings:results[0]///默认选择第一个
                    });
                    window.localStorage.setItem('systemInfo',JSON.stringify(results[0]));
                }
            }
        });
        window.addEventListener('hashchange', (event)=>{
               let hash=window.location.hash;
               let key=GetUrlParam('key');
               let menus=this.props.menus;
               let newHash=hash.split('?')[0];
               if(newHash.split('/')[1]===''){
                   _this.setState({
                       current:'index_#/'
                   });
                   window.sessionStorage.setItem('current','index_#/')
               }else {
                   let newHash2=  newHash.split('/')[0]+'/'+newHash.split('/')[1];

                   _this.setCurrent(menus,newHash2,key,_this);

               }
        });
        let extension_time=window.localStorage.getItem('extension_time');////获取上次推广弹框的时间
        let now_time=moment().format('YYYY-MM-DD');
        //if(!extension_time||(extension_time&&now_time!==extension_time)){//本地没有上次弹框时间 或者 本地存了上次的时间，并且和当前日期不相等
        if(!extension_time){//没有弹过，就弹出提示
            Axios.get('/api/v1/news/',{channel__name:'弹窗推荐'}).then((res)=>{
                if(res){
                    console.log(res);
                    if(res.results.length>0){///个数大于0，取第一个数据
                        window.localStorage.setItem("extension_time",now_time);///将本次弹窗的时间存储起来
                        _this.setState({
                            isModalOpen:true,
                            extension:res.results[0]
                        })
                    }
                }
            })
        }
    }
    setCurrent=(menus,newHash,key,_this)=>{
        if(key){///文章类的菜单，url里含有key字段
            for(let i=0;i<menus.length;i++){
                if(menus[i].key===key){
                    _this.setState({
                        current:menus[i].key+"_"+menus[i].hash
                    });
                    window.sessionStorage.setItem('current',menus[i].key+"_"+menus[i].hash);
                    return false
                }
                if(menus[i].children){
                    let children2=menus[i].children;
                    for(let j=0;j<children2.length;j++){
                        if(children2[j].key===key){
                            _this.setState({
                                current:children2[j].key+"_"+children2[j].hash
                            });
                            window.sessionStorage.setItem('current',children2[j].key+"_"+children2[j].hash);
                            return false
                        }
                        if(children2[j].children){
                            let children3=children2[j].children;
                            for(let k=0;k<children3.length;k++){
                                if(children3[k].key===key){
                                    _this.setState({
                                        current:children3[k].key+"_"+children3[k].hash
                                    });
                                    window.sessionStorage.setItem('current',children3[k].key+"_"+children3[k].hash);
                                    return false
                                }
                                if(children3[k].children){
                                    let children4=children3[k].children;
                                    for(let l=0;l<children4.length;l++){
                                        if(children4[l].key===key){
                                            _this.setState({
                                                current:children4[l].key+"_"+children4[l].hash
                                            });
                                            window.sessionStorage.setItem('current',children4[l].key+"_"+children4[l].hash);
                                            return false
                                        }

                                    }
                                }
                            }
                        }
                    }
                }
            }
        }else {
            for(let i=0;i<menus.length;i++){
                if(menus[i].hash===newHash){
                    _this.setState({
                        current:menus[i].key+"_"+menus[i].hash
                    });
                    window.sessionStorage.setItem('current',menus[i].key+"_"+menus[i].hash);
                    return false
                }
            }
            ///不在menus列表内的，随便设置值，将菜单的选中状态取消
            _this.setState({
                current:'usersInfo'
            });
            window.sessionStorage.setItem('current','usersInfo');
        }
    };
    toLogin=()=>{
        window.open('http://api.ticks.precisiongenes.com.cn/admin','_blank')
    };
    handleClick = e => {
        console.log('路由信息',e);
        window.localStorage.setItem("keyPath",JSON.stringify(e.keyPath));
        let hash = e.key.split("_")[1];
        if(!hash.match('news')){///不是文章类的
            this.setState({
                current:e.key
            });
            window.location.hash = hash;
        }else {//文章类的
            this.setState({
                current:e.key
            });
            let name=e.item.props.children[1];//获取菜单的中文名称，判断是教育类文章还是普通文章
            if(typeof name.match === 'function' && (name.match('继续教育')||name.match('患者频道'))){
                window.location.hash = hash+"?key="+ e.key.split('_')[0]+'&st=1';//st=study，区分教育类文章还是普通文章，请求train还是news接口
            }else {
                window.location.hash = hash+"?key="+ e.key.split('_')[0];
            }

        }

    };
    onPressEnter=(e)=>{
        window.location.hash='#/news?search='+e.target.value
    };
    onSearch=(value)=>{
        window.location.hash='#/news?search='+value
    };
    toOut=()=>{//登出功能
        window.client2.disconnect(function() {
            console.log('清除成功！');
        });
        window.localStorage.removeItem('token');//清除信息
        window.localStorage.removeItem('userInfo');//清除信息
        window.location.hash='#/';
        this.props.toSetMenus();///重置网站菜单
        this.setState({
            userName:'',
            isGrade_name:0
        });
    };
    toCloseModel=()=>{
        this.setState({
            isModalOpen:false
        })
    };
    toShowNews=(id,channel)=>{///查看弹框详情
        let channel_id=getIdFromUrl(channel);
        window.open('#/news/newshow?id='+id+'&key='+channel_id,'_blank');
    };
    toShowDataAnalysis=()=>{
        //window.open('#/data_analysis','_blank')
        window.location.hash='#/data_analysis'
    };
    render() {
        const { current,friend_link,system_settings,userName,isModalOpen,extension,isGrade_name,friend_link_num} = this.state;
        const {menus}=this.props;
        return (
            <div style={{width:'100%',height:'100%'}}>
                <IsPcChild  IsPC={IsPC()} >{/*pc端*/}
                    <div className='index_pc'>
                        <div className='top_title'>
                            <div style={{width:'1200px',margin:'auto',position:'relative'}}>
                                <span style={{paddingLeft:'15px'}}>欢迎访问{system_settings.site_name}</span>
                                <div className='login_out'>
                                    <span><a href="#/news/newshow?ab=1"  target = "_blank" style={{color:'white'}}>联系我们</a></span> |
                                    {userName?<span ><a href="#/usersInfo" style={{color:'white'}}>个人中心</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="" style={{color:'white',textDecoration:'none',cursor:'default'}}>欢迎您，{userName}</a>&nbsp;&nbsp;&nbsp;<span className='toOut' onClick={()=>this.toOut()}><span className={'iconfont icondengchu'} />登出</span></span>:
                                        <span>请先<a href='#/login' style={{color:'white'}}>登录</a></span>}


                                </div>
                                <div className='small_program'>
                                    <span className='iconfont iconerweima' />
                                    <span>微信小程序</span>
                                    {system_settings.wechat_applet_icon?
                                        <div className='QR_code' style={{backgroundImage:'url('+system_settings.wechat_applet_icon.file+')'}} />:''
                                    }
                                </div>
                                {
                                    isGrade_name?
                                    <div className='small_program' onClick={this.toShowDataAnalysis.bind(this)}>
                                        <span className='iconfont iconshuju' />
                                        <span>数据分析</span>
                                    </div>:''
                                }

                            </div>
                        </div>
                        <div style={{width:'1200px',margin:'auto',position:'relative',padding:'10px 0'}}>
                            <a href='#/'>
                                {system_settings.small_logo?
                                    <span className='logo' style={{backgroundImage:'url('+system_settings.small_logo.file+')'}} />
                                   :<span className='logo' />
                                }

                            </a>
                            <div className='search'>
                                <Search
                                    style={{width:'240px'}}
                                    placeholder=""
                                    allowClear
                                    enterButton="搜索"
                                    onPressEnter={this.onPressEnter.bind(this)}
                                    onSearch={this.onSearch.bind(this)}
                                />
                            </div>
                        </div>
                        <Menu  onClick={this.handleClick} selectedKeys={[current]} mode="horizontal" style={{width:'1200px',margin:'auto'}}>
                            {menus.map((item)=>{
                                if(!item.children){
                                    return   <Menu.Item key={item.key+"_"+item.hash} icon={<span className={item.iconfont} />}>
                                        {item.name}
                                    </Menu.Item>
                                }else {
                                   return <SubMenu key={item.key+"_"+item.hash} icon={<span className={item.iconfont} />} title={item.name}>
                                           {item.children.map((item2)=>{
                                               if(!item2.children){
                                                   return <Menu.Item key={item2.key+"_"+item2.hash}>{item2.name}</Menu.Item>
                                               }else {
                                                  return <SubMenu key={item2.key+"_"+item2.hash} title={item2.name}>
                                                      {item2.children.map((item3)=>{
                                                          if(!item3.children){
                                                              return <Menu.Item key={item3.key+"_"+item3.hash}>{item3.name}</Menu.Item>
                                                          }else {
                                                              return <SubMenu key={item3.key+"_"+item3.hash} title={item3.name}>
                                                                  {item3.children.map((item4)=>{
                                                                      return <Menu.Item key={item4.key+"_"+item4.hash}>{item4.name}</Menu.Item>
                                                                  })}
                                                              </SubMenu>
                                                          }
                                                      })}
                                                   </SubMenu>
                                               }
                                           })}
                                    </SubMenu>
                                }
                            })}
                        </Menu>
                        <div style={{width:'100%',minHeight:'calc(100% - 90px - 38px - 24px - 116.4px)'}}>
                            {this.props.children}
                        </div>
                        <div className='footer'>
                            <div style={{width:'1200px',margin:'auto',position:'relative'}} className='clear'>
                                { new Array(friend_link_num).fill(null).map((_, index) =>{
                                    if(index===0){
                                        return   <div style={{float:'left'}} key={index}>
                                            <p><b>友情链接：</b></p>
                                            {friend_link?friend_link.map((item2,index2)=>{
                                                if(index2<4*(index+1)){
                                                    return  <p key={index2}><a href={item2.redirect_url} rel="noreferrer" target = "_blank">{item2.site_name}</a></p>
                                                }
                                            }):''}

                                        </div>
                                    }else {
                                        return <div style={{float:'left',paddingLeft:'60px'}}>
                                            <p style={{height:'16px'}}><b> </b></p>
                                            {friend_link?friend_link.map((item2,index2)=>{
                                                if((index*4 <= index2)&&(index2 < 4*(index+1))){
                                                    return  <p key={index2}><a href={item2.redirect_url} rel="noreferrer" target = "_blank">{item2.site_name}</a></p>
                                                }
                                            }):''}
                                        </div>
                                    }
                                })}

                                {/*{friend_link_num === 1?
                                    <div style={{float:'left'}}>
                                        <p><b>友情链接：</b></p>
                                        {friend_link?friend_link.map((item,index)=>{
                                            return  <p key={index}><a href={item.redirect_url} rel="noreferrer" target = "_blank">{item.site_name}</a></p>
                                        }):''}

                                    </div>:
                                    new Array(friend_link_num).fill(null).map((_, index) => (
                                        index===0?<div style={{float:'left',paddingLeft:'10px'}}>
                                            <p><b>友情链接：</b></p>
                                            {friend_link?friend_link.map((item,index1)=>{
                                                if (index1<4){
                                                    return  <p key={index1}><a href={item.redirect_url} rel="noreferrer" target = "_blank">{item.site_name}</a></p>
                                                }
                                            }):''}
                                        </div>:<div style={{float:'left',paddingLeft:'60px'}}>
                                            <p style={{height:'16px'}}><b> </b></p>
                                            {friend_link?friend_link.map((item,index2)=>{
                                                if (index2<(index*4)&&index2>((index-1)*4)){
                                                    return  <p key={index2}><a href={item.redirect_url} rel="noreferrer" target = "_blank">{item.site_name}</a></p>
                                                }
                                            }):''}
                                        </div>
                                        ))
                                }*/}
                                {system_settings.id?
                                    <div style={{float:'left',paddingLeft:'100px'}}>
                                        <p><b>网站信息：</b></p>
                                        <p>{system_settings.other_info}2021-{new Date().getFullYear()}</p>
                                        <p><a href={system_settings.record_link} rel="noreferrer" target = "_blank">{system_settings.record}</a></p>
                                        <p><a href={'http://www.precisiongenes.com.cn/'} rel="noreferrer" target = "_blank">网站制作与维护：中科基因生物科技(江苏)有限公司</a></p>
                                       {/* <p>联系电话：***********</p>*/}
                                    </div>
                                    :''
                                }
                                <div style={{float:'left',paddingLeft:'140px'}}>
                                    <span id="" style={{position:'absolute',top:'0px'}}>
                                            <a href="https://tongji.baidu.com/sc-web/10000383206/home/site/index?from=3" target="_blank" rel="noreferrer" title="百度统计">
                                                <img border="0" hspace="0" vspace="0" src={baiduico} alt='百度统计' style={{width:'15px',height:'15px',marginTop:'-2px',marginRight:'4px'}} />
                                                <span style={{color:'white'}}>百度统计</span>
                                                </a></span>
                                </div>
                                {/*<div style={{float:'left',paddingLeft:'140px'}}>
                                    <span id="cnzz_stat_icon_1280015743_copy" style={{position:'absolute',}}>
                                            <a href="https://www.cnzz.com/stat/website.php?web_id=1280015743" target="_blank" rel="noreferrer" title="站长统计">
                                                <img border="0" hspace="0" vspace="0" src="https://icon.cnzz.com/img/pic.gif" alt='cnzz' /></a></span>
                                </div>*/}
                            </div>
                        </div>
                    </div>
                </IsPcChild>
                <IsPcChild  IsPC={!IsPC()} >{/*手机端*/}
                    <div className='index_mobile'>
                        <div className='little_top'>
                            <span>欢迎访问本网站</span>
                            <div className='login_out'>
                                {userName?<span  style={{lineHeight: '16px'}}><a href="#/usersInfo" style={{color:'white'}}>欢迎您，{userName}</a>&nbsp;&nbsp;&nbsp;<span className='toOut' onClick={()=>this.toOut()}><span className={'iconfont icondengchu'} />登出</span></span>:
                                    <span>请先<a href='#/login' style={{color:'white'}}>登录/注册</a></span>}
                            </div>
                        </div>
                        <div className='logo' />
                       {/* <div style={{width:'100%',padding:' 0 10px',background:'#f1f1f1'}}>
                            <ScrollSpan />
                        </div>*/}
                        <Menu  onClick={this.handleClick} selectedKeys={[current]} mode="horizontal" style={{width:'100%',margin:'auto'}}>
                            {menus.map((item)=>{
                                if(!item.children){
                                    return    <Menu.Item key={item.key+"_"+item.hash} icon={<span className={item.iconfont} />}>
                                        {item.name}
                                    </Menu.Item>
                                }else {
                                    return <SubMenu key={item.key+"_"+item.hash} icon={<span className={item.iconfont} />} title={item.name}>
                                        {item.children.map((item2)=>{
                                            if(!item2.children){
                                                return <Menu.Item key={item2.key+"_"+item2.hash}>{item2.name}</Menu.Item>
                                            }else {
                                                return <SubMenu key={item2.key+"_"+item2.hash} title={item2.name}>
                                                    {item2.children.map((item3)=>{
                                                        if(!item3.children){
                                                            return <Menu.Item key={item3.key+"_"+item3.hash}>{item3.name}</Menu.Item>
                                                        }else {
                                                            return <SubMenu key={item3.key+"_"+item3.hash} title={item3.name}>
                                                                {item3.children.map((item4)=>{
                                                                    return <Menu.Item key={item4.key+"_"+item4.hash}>{item4.name}</Menu.Item>
                                                                })}
                                                            </SubMenu>
                                                        }
                                                    })}
                                                </SubMenu>
                                            }
                                        })}
                                    </SubMenu>
                                }
                            })}
                        </Menu>
                        <div style={{width:'100%'}}>
                            {this.props.children}
                        </div>
                        <div className='friend_link' style={{background:'#f7f7f7',paddingBottom:'2vw',paddingTop:'2vw'}}>
                            <p><b>友情链接：</b></p>
                            {friend_link?friend_link.map((item,index)=>{
                                    return <p key={index}><a href={item.redirect_url} rel="noreferrer" >{item.site_name}</a></p>
                            }):''}
                        </div>
                        <div className='friend_link' style={{background:'#f7f7f7',paddingBottom:'4vw'}}>
                            <p><b>网站信息：</b></p>
                            <p><a href={system_settings.record_link} rel="noreferrer">{system_settings.record}</a></p>
                            <p><a href={'http://www.precisiongenes.com.cn/'} rel="noreferrer">网站制作与维护：中科基因生物科技(江苏)有限公司</a></p>
                            <p style={{marginBottom:'0'}}>{system_settings.other_info}2021-{new Date().getFullYear()}</p>
                        </div>
                       {/* <div className='footer clear'>
                            <p>联系电话：***********</p>


                        </div>*/}
                    </div>
                </IsPcChild>
                <Modal visible={isModalOpen}
                       footer={null}
                       onCancel={this.toCloseModel.bind(this)}
                >
                    <div style={{width:'100%',textAlign:'center'}}>
                        <Image preview={false} src={extension.big_image?extension.big_image.file:''} width='93%' style={{marginTop:'15px',marginBottom:'15px'}}/>
                        <Button onClick={this.toShowNews.bind(this,extension.id,extension.channel)}>查看详情</Button>
                    </div>
                </Modal>
            </div>
        );
    }
}
